const ROLES = {
    USER: 'ROLE_USER',
    RDG: 'ROLE_RDG',
    RCG_PRESTA: 'ROLE_RCG_PRESTA',
    AGENT_GRDF: 'ROLE_AGENT_GRDF',
};

export function hasRole(user, role) {
    return Array.isArray(user?.roles) && user.roles.includes(role);
}

export function useRoles(user) {
    const isAgentGrdf  = hasRole(user, ROLES.AGENT_GRDF);
    const isRdg        = hasRole(user, ROLES.RDG);
    const isRcgPresta  = hasRole(user, ROLES.RCG_PRESTA);

    return {
        canAccessRdg:  isRdg,
        canAccessRcg:  isAgentGrdf || isRcgPresta,
        isAgentGrdf:   isAgentGrdf,
        isOnlyRdg:     isRdg && !isAgentGrdf && !isRcgPresta,
        isRcgOnly:     (isRcgPresta || isAgentGrdf) && !isRdg,
    };
}

export { ROLES };
